module.exports = __webpack_public_path__ + "static/media/as8tj0.0e271607.png";